<template>
    <div style="padding: 20px">
        <div style="height: 80px"></div>
        <img src="../assets/refuse.png" with="80px" height="80px" style="display: block;margin: 0 auto;">
        <p style="text-align: center;margin-top: 20px;color: #8e8e8e;">{{msg}}</p>
        <div style="height: 100px"></div>
    </div>
</template>

<script>
    export default {
        name: 'error',

        data() {
            return {
                msg:'',
            }
        },

        methods: {
          getQueryVariable: function (variable) {
            let query = window.location.search.substring(1);
            let vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
              let pair = vars[i].split("=");
              if (pair[0] == variable) {
                return pair[1];
              }
            }
            return '';
          },
        },

        mounted() {
          let msg = this.getQueryVariable("msg");
          if(msg != null && msg != ''){
            this.msg = decodeURIComponent(msg);
          }
        }
    }
</script>

<style scoped>
.btn{
  width: 100%;
  height: 50px;
  background: #F85F49;
  border-radius: 15px;
  color: white;
  border: none;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 20px;
}
</style>